module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M0 16v12c0 1.106.894 2 2 2s2-.894 2-2h2v2c0 1.106.894 2 2 2 1.106 0 2-.894 2-2v-8c0-1.106-.894-2-2-2-1.106 0-2 .894-2 2v2H4v-8C4 9.382 9.382 4 16 4s12 5.382 12 12v8h-2v-2c0-1.106-.894-2-2-2-1.106 0-2 .894-2 2v8c0 1.106.894 2 2 2 1.106 0 2-.894 2-2v-2h2c0 1.106.894 2 2 2s2-.894 2-2V16c0-8.836-7.164-16-16-16S0 7.164 0 16z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/headphones-1.js
// module id = 1169
// module chunks = 14